import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import { useFareGroupsCompareTableQuery } from '@websky/graphql';
import { Notes } from '../../types';
import ModalHeading from '../../../ModalHeading';
import { useTheme } from '../../../theme';
import MediaQuery from '../../../MediaQuery/MediaQuery';
import { useCompareFaresModel } from './../../CompareFares.hook';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import FaresSlider from '../FaresSlider/FaresSlider';

export interface Props {
	notes?: Notes;
	selectedFare?: string;
	selectedFareName?: string;
	orderId?: string;
}

const CompareFares: React.FunctionComponent<Props> = ({ notes, selectedFare, orderId, selectedFareName }) => {
	const { CompareFares: css } = useTheme('CompareFares');
	const { t } = useTranslation('CompareFares');

	const model = useCompareFaresModel(orderId);

	const { data: compareTable, loading, error } = useFareGroupsCompareTableQuery({
		variables: model.compareTableVariables,
		skip: !model.compareTableVariables.flightId && !model.compareTableVariables.orderId
	});

	const headerRef: React.RefObject<HTMLDivElement> = React.useRef();

	return (
		<Paper classes={{ root: css.compareFares }}>
			<MediaQuery minWidth={'mobile'}>
				<ModalHeading heading={t('Compare fare families')} />
			</MediaQuery>

			<div className={css.container} ref={headerRef}>
				{loading && (
					<div className={css.loaderWrp}>
						<CircularProgress classes={{ colorPrimary: css.loader }} />
					</div>
				)}

				{!loading && (
					<>
						<ErrorMessage error={error} />

						<FaresSlider
							headerRef={headerRef}
							isLoading={loading}
							compareTable={compareTable}
							selectedFareName={selectedFareName}
							selectedFare={selectedFare}
							notes={notes}
						/>
					</>
				)}
			</div>
		</Paper>
	);
};

export default CompareFares;
